// src/themes/dark.js

export default {
  colors: {
    background: "#2E3440",
    textColor: "#ECEFF4",
    sliderBgColor: "#2E3440",
    tableBgColor: "#2E3440"
  },
};
